import { Children } from 'react';
import { Breakpoint, Spacer } from '../../../../types';

export type RowProps = React.HTMLAttributes<HTMLDivElement> & {
	py?: Spacer;
	pt?: Spacer;
	pb?: Spacer;
	pullOut?: boolean;

	breakpoint?: Breakpoint;

	left?: React.ReactNode;
	right?: React.ReactNode;
	children?: [left: React.ReactNode, right: React.ReactNode];
};

export const Row: React.FC<RowProps> = ({
	py = 1,
	pt = py,
	pb = py,
	pullOut,
	left,
	right,
	children,
	className,
	breakpoint = 'xms',
	...props
}) => {
	const [l, r] = Children.toArray(children);

	return (
		<div
			className={`order-details-row row pt-${pt} pb-${pb}${
				pullOut ? '' : ' no-gutters'
			}${className ? ` ${className}` : ''}`}
			{...props}
		>
			<div className={`font-weight-bold col-12 col-${breakpoint}-3 p-0`}>
				{left ?? l}
			</div>

			<div className={`col-12 col-${breakpoint}-9 p-0`}>{right ?? r}</div>
		</div>
	);
};
